<template>
  <div>
    <v-card v-if="paStatus.is_kp_pa" tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <v-list class="py-0">
              <v-list-item class="px-0">
                <v-list-item-avatar color="success" size="50">
                  <v-icon dark>mdi-account</v-icon>
                </v-list-item-avatar>
                <v-list-item-content class="py-0 px-1">
                  <v-row>
                    <v-col cols="12" lg="6">
                      <div class="caption grey--text">Nama FSP</div>
                      <div class="body-1 black--text font-weight-medium">
                        {{ ptk.nama }}
                      </div>
                    </v-col>
                    <v-col v-if="false" cols="12" lg="4">
                      <div class="caption grey--text">Predikat</div>
                      <div class="body-1 black--text font-weight-medium">
                        <v-chip
                          :class="['white--text']"
                          :color="
                            colorPredikat[
                              $getDeepObj(meta, 'rekap.m_kinerja_predikat_psp.k_kinerja_predikat_psp') || -1
                            ]
                          "
                          dark
                        >
                          {{
                            $getDeepObj(meta, 'rekap.m_kinerja_predikat_psp')
                              ? $getDeepObj(meta, 'rekap.m_kinerja_predikat_psp.keterangan')
                              : 'Belum Ada'
                          }}
                        </v-chip>
                      </div>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <list-kinerja ref="list" @meta="onMeta" :is-allow-edit="true" />
  </div>
</template>

<script>
import ListKinerja from '../kinerja/List';
import { mapState } from 'vuex';

export default {
  name: 'PenilaianKinerja',
  components: { ListKinerja },
  data() {
    return {
      meta: {},
      colorPredikat: {
        '-1': 'grey',
        1: 'green',
        2: 'blue',
        3: 'orange',
      },
    };
  },
  computed: {
    ...mapState('preferensi', {
      paStatus: (state) => state.data?.pelatih_ahli_status ?? {},
      ptk: (state) => state.data?.ptk ?? {},
    }),
  },
  mounted() {
    this.$refs.list.fetchData();
  },
  methods: {
    onMeta(meta) {
      this.meta = meta;
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
</style>
